import React from "react";
import { attendanceBenifitData } from "../../../assets/json/attendanceBenifitData";
import InfoCard2 from "../../Common/InfoCard2";
import FullWidthHeading from "../../Device/FullWidthHeading";

const AttendanceManagementBenifits = () => {
  return (
    <>
      <div className="payroll-benifits AttendanceManagement-benifits">
        <div className="container">
          <div className="row">
            <div className="com-lg-12">
              <FullWidthHeading
                sectionTitle="FEATURES"
                title="Seamless Attendance Management for a Productive Workforce"
                desc="Empower your team with efficient time tracking and real-time insights."
              />
            </div>
            {attendanceBenifitData.map((item, index) => (
              <div key={index} className="col-lg-3 mb-4">
                <InfoCard2
                  id={item.id}
                  icon={item.icon}
                  title={item.title}
                  desc={item.desc}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default AttendanceManagementBenifits;
